import { render, staticRenderFns } from "./resetpw.vue?vue&type=template&id=5b2c8980&"
import script from "./resetpw.vue?vue&type=script&lang=ts&"
export * from "./resetpw.vue?vue&type=script&lang=ts&"
import style0 from "./resetpw.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports